import { useMutation, useQueryClient } from '@tanstack/react-query';
import { entriesApi } from '../../../api/entries';
import { TimeEntry } from '../../../types';
import { EntryActionsMenu } from '../../../components/ui/organisms/entry-actions-menu';

export function Loading() {
  return (
    <div className="flex h-40 items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
    </div>
  );
}

// ─── Admin override actions (IS_ADMIN only) ──────────────────────────────────
// Bypasses the normal scrum/lead/manager role gates — can approve, reject, or
// request an edit on any entry regardless of its current status.

export function AdminEntryActions({
  entry,
  onRequestNote,
}: {
  entry: TimeEntry;
  onRequestNote: (entry: TimeEntry, action: 'request-edit' | 'reject') => void;
}) {
  const queryClient = useQueryClient();

  const approveMutation = useMutation({
    mutationFn: () => entriesApi.approve(entry.id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin-entries'] }),
  });

  return (
    <EntryActionsMenu
      onApprove={() => approveMutation.mutate()}
      approveDisabled={approveMutation.isPending}
      onRequestEdit={() => onRequestNote(entry, 'request-edit')}
      onReject={() => onRequestNote(entry, 'reject')}
    />
  );
}
